import { useQuery } from '@tanstack/react-query';

export interface FormFieldItem {
  field_type: 'fixed' | 'custom';
  field_key: string | null;
  custom_field_id: number | null;
  name: string;
  enabled: boolean;
  is_required: boolean;
  enabled_locked: boolean;
  required_locked: boolean;
  position: number;
}

export interface FormFieldsResponse {
  items: FormFieldItem[];
}

export const ALLIANCE_FORM_FIELDS_QUERY_KEY = ['alliance_form_fields'] as const;

export default function useFetchFormFields() {
  return useQuery({
    queryKey: ALLIANCE_FORM_FIELDS_QUERY_KEY,
    queryFn: async () => {
      const response = await fetch('/agent/api/alliance_setting/form_fields');
      if (!response.ok) {
        throw new Error('応募項目設定の取得に失敗しました');
      }
      const data: FormFieldsResponse = await response.json();
      return data;
    },
  });
}
